document.addEventListener('DOMContentLoaded', function() {
  const tabList = document.querySelector('.benefits-toggle-tab__tab-list');
  const tabItems = document.querySelectorAll('.benefits-toggle-tab__tab-list-item');
  const tableCategoryWrappers = document.querySelectorAll('.benefits-toggle-tab__table-category-wrapper');

  if (tabList && tabItems && tableCategoryWrappers) {
    tabList.addEventListener('click', function(event) {
      const clickedTab = event.target.closest('.benefits-toggle-tab__tab-list-item');
      const anchor = event.target.closest('a');

      if (clickedTab && anchor) {
        event.preventDefault();

        // Remove active class from all tabs
        tabItems.forEach(item => {
          item.classList.remove('active');
        });

        // Add active class to the clicked tab
        clickedTab.classList.add('active');

        const targetId = anchor.getAttribute('href').substring(1);

        // Hide all table content and show the target content
        tableCategoryWrappers.forEach(wrapper => {
          wrapper.classList.remove('active');
          if (wrapper.id === targetId) {
            wrapper.classList.add('active');
          }
        });
      }
    });
  }
});